module.exports = __webpack_public_path__ + "images/patterns/pattern_bg_dot_blue_5361a5d2ed66802e9010a5b186b1213a.webp";